import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'totalpages'})
export class TotalPagesPipe implements PipeTransform {
    transform(totalLeads: number, pageSize: number): number {
        return Math.ceil(totalLeads / pageSize);
    }
}
